import React from "react";
import "./CardStyled.scss";

const CardStyled = ({ children, className, ...restProps }) => {
  return <div className={`styled-card ${className}`} {...restProps}>{children}</div>;
};
export default CardStyled;
